import { SquareMenu } from "lucide-react";
import { motion, useAnimation } from "framer-motion";
import { ChatStore } from "@/stores/ChatStore";
import { cn } from "@/lib/utils";

export default function HistoryPanelTrigger() {
  const controls = useAnimation();
  const isHistoryPanelOpen = ChatStore(state => state.isHistoryPanelOpen);
  const isRunning = ChatStore(state => state.isRunning);
  const setIsHistoryPanelOpen = ChatStore(state => state.setIsHistoryPanelOpen);

  const handleClick = async () => {
    setIsHistoryPanelOpen(!isHistoryPanelOpen);
    await controls.start({
      scale: [1, 1.1, 1],
      transition: { duration: 0.3, ease: "easeInOut" },
    });
  };

  return (
    <motion.button
      className={cn(
        !isRunning && "opacity-50",
        isRunning && "shadow-lg",
        "flex h-14 w-14 items-center justify-center rounded-full bg-white text-primary shadow-lg transition-colors duration-200 ease-in-out"
      )}
      whileHover={{ scale: !isRunning ? 1 : 1.1 }}
      whileTap={{ scale: !isRunning ? 1 : 0.9 }}
      animate={controls}
      onClick={handleClick}
      aria-label="Messages"
      disabled={!isRunning}
    >
      <SquareMenu className="h-6 w-6" strokeWidth={2} />
    </motion.button>
  );
}
